import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import SinglePost from "../components/description/SinglePost";
import HomeBtn from "../components/navbar/HomeBtn";
import Loading from "../components/ui/Loading";
import { fetchPost } from "../features/post/postSlice";
import RelatedPostList from "../components/list/RelatedPostList";

export default function Post() {
  const { post, isLoading, isError, error } = useSelector(
    (state) => state.post
  );
  const dispatch = useDispatch();
  const { postId } = useParams();
  useEffect(() => {
    dispatch(fetchPost(postId));
  }, [dispatch, postId]);

  const { id, tags } = post || {};

  // decide what to render
  let content = null;
  if (isLoading) content = <Loading />;

  if (!isLoading && isError)
    content = <div className="col-span-12">{error}</div>;

  if (!isLoading && !isError && !post?.id) {
    content = <div className="col-span-12">No Post found!</div>;
  }

  if (!isLoading && !isError && post?.id) {
    content = (
      <section className="post-page-container">
        <SinglePost post={post} />
        <aside>
          <h4 className="mb-4 text-xl font-medium" id="lws-relatedPosts">
            Related Posts
          </h4>          
            <RelatedPostList currentPostId={id} tags={tags} />         
        </aside>
      </section>
    );
  }

  return (
    <>
      <HomeBtn />
      {content}
    </>
  );
}
